import styled, { css } from 'styled-components';
import { Breakpoints } from '../../../../styled/constants';
import { Typography } from '../../../ui/Typography';

export const MapButton = styled.button<{ $isMapView?: boolean }>`
  background-color: ${({ theme }) => theme.colors.background.primary};
  border: 1px solid ${({ theme }) => theme.colors.border.secondary};
  padding: 15px;
  display: flex;
  height: 50px;
  justify-content: center;
  align-items: center;
  gap: 5px;
  border-radius: 14px;
  text-decoration: none;
  box-sizing: border-box;
  width: 50px;

  -webkit-tap-highlight-color: transparent;
  outline: none;
  user-select: none;

  &:focus,
  &:active,
  &:focus-visible {
    outline: none;
  }

  svg path {
    transition:
      fill 0.3s ease-in-out,
      stroke 0.3s ease-in-out;
  }

  @media screen and (min-width: ${Breakpoints.tablet}px) {
    width: 120px;
    cursor: pointer;
  }

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      span {
        transition: color 0.3s ease-in-out;
        color: ${({ theme }) => theme.colors.systemColors.blue};
      }

      svg path {
        ${({ $isMapView }) =>
          $isMapView
            ? css`
                stroke: ${({ theme }) => theme.colors.systemColors.blue};
              `
            : css`
                fill: ${({ theme }) => theme.colors.systemColors.blue};
              `}
      }
    }
  }
`;

export const MapLinkText = styled(Typography)`
  @media (max-width: ${({ theme }) => theme.tabletBreakpoint}) {
    display: none;
  }

  color: ${({ theme }) => theme.colors.text.primary};
`;
